<template>
  <div class="premium-tab-content">
    <div class="premium-card-section mb-4">
      <div class="modal-section-title mb-3">
        <i class="fa fa-university mr-2 text-primary"></i> PIS - Programa de Integração Social
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group label="CST - Situação Tributária" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_PIS_SITUACAO_TRIBUTARIA"
              :options="sitTribOptions"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="onSituacaoChange"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Tipo de Cálculo" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_PIS_TIPO_CALCULO"
              :options="tipoCalculoOptions"
              :disabled="!camposAtivos.tipoCalculo"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="onTipoCalculoChange"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="camposAtivos.aliquotaPercentual">
        <b-col md="4">
          <b-form-group label="Alíquota %" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_PIS_ALIQUOTA_PERCENT"
              :options="autonumericOptions.percentual"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="premium-card-section bg-soft-info p-3 rounded-lg border-info-light">
      <div class="modal-section-title mb-3 text-info">
        <i class="fa fa-random mr-2"></i> PIS ST
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group label="Tipo de Cálculo ST" label-class="modal-label-premium">
            <b-form-select
              v-model="local.OP_PISST_TIPO_CALCULO"
              :options="tipoCalculoOptions"
              class="rounded-pill shadow-xs custom-select-premium"
              @change="onTipoCalculoSTChange"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="camposAtivos.aliquotaPercentualST">
          <b-form-group label="Alíquota ST %" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_PISST_ALIQUOTA_PERCENT"
              :options="autonumericOptions.percentual"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'

export default {
  name: 'NfeProdutoPis',
  components: { VueAutonumeric },
  props: { value: { type: Object, default: () => ({}) } },
  data() {
    return {
      local: {},
      autonumericOptions: {
        percentual: {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalPlaces: 2,
          minimumValue: '0'
        }
      },
      sitTribOptions: [
        { value: null, text: 'Selecione...' },
        { value: '01', text: '01 - Operação Tributável com Alíquota Básica' },
        { value: '02', text: '02 - Operação Tributável com Alíquota Diferenciada' },
        { value: '03', text: '03 - Operação Tributável por Quantidade' },
        { value: '04', text: '04 - Operação Tributável Monofásica - Revenda a Alíquota Zero' },
        { value: '06', text: '06 - Operação Tributável a Alíquota Zero' },
        { value: '07', text: '07 - Operação Isenta da Contribuição' },
        { value: '08', text: '08 - Operação sem Incidência da Contribuição' },
        { value: '09', text: '09 - Operação com Suspensão da Contribuição' },
        { value: '49', text: '49 - Outras Operações de Saída' },
        { value: '50', text: '50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada' },
        { value: '51', text: '51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada' },
        { value: '52', text: '52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação' },
        { value: '53', text: '53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não Tributada' },
        { value: '54', text: '54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Exportação' },
        { value: '55', text: '55 - Operação com Direito a Crédito - Vinculada a Receitas Não Tributada e Exportação' },
        { value: '56', text: '56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas, Não Tributada e Exportação' },
        { value: '60', text: '60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada' },
        { value: '61', text: '61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não Tributada' },
        { value: '62', text: '62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação' },
        { value: '63', text: '63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não Tributadas' },
        { value: '64', text: '64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e de Exportação' },
        { value: '65', text: '65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não Tributadas e de Exportação' },
        { value: '66', text: '66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas, Não Tributadas e de Exportação' },
        { value: '67', text: '67 - Crédito Presumido - Outras Operações' },
        { value: '68', text: '68 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno' },
        { value: '70', text: '70 - Operação de Aquisição sem Direito a Crédito' },
        { value: '71', text: '71 - Operação de Aquisição com Isenção' },
        { value: '72', text: '72 - Operação de Aquisição com Suspensão' },
        { value: '73', text: '73 - Operação de Aquisição a Alíquota Zero' },
        { value: '74', text: '74 - Operação de Aquisição sem Incidência da Contribuição' },
        { value: '75', text: '75 - Operação de Aquisição por Substituição Tributária' },
        { value: '98', text: '98 - Outras Operações de Entrada' },
        { value: '99', text: '99 - Outras Operações' }
      ],
      tipoCalculoOptions: [
        { value: null, text: 'Sem cálculo manual' },
        { value: '1', text: '1 - Percentual' },
        { value: '2', text: '2 - Valor' }
      ]
    }
  },
  computed: {
    camposAtivos() {
      const situacao = this.local.OP_PIS_SITUACAO_TRIBUTARIA
      const exigeTipoCalculo = [
        '49', '50', '51', '52', '53', '54', '55', '56',
        '60', '61', '62', '63', '64', '65', '66', '67',
        '68', '70', '71', '72', '73', '74', '75', '98', '99'
      ].includes(situacao)

      return {
        tipoCalculo: exigeTipoCalculo,
        aliquotaPercentual: ['01', '02'].includes(situacao) || (exigeTipoCalculo && this.local.OP_PIS_TIPO_CALCULO === '1'),
        aliquotaPercentualST: this.local.OP_PISST_TIPO_CALCULO === '1'
      }
    }
  },
  watch: {
    value: {
      handler(v) {
        this.local = v || {}
      },
      immediate: true
    }
  },
  methods: {
    onSituacaoChange() {
      if (!this.camposAtivos.tipoCalculo) {
        this.local.OP_PIS_TIPO_CALCULO = null
      }
      if (!this.camposAtivos.aliquotaPercentual) {
        this.local.VL_PIS_ALIQUOTA_PERCENT = 0
      }
      this.emit()
    },
    onTipoCalculoChange() {
      if (this.local.OP_PIS_TIPO_CALCULO !== '1') {
        this.local.VL_PIS_ALIQUOTA_PERCENT = 0
      }
      this.emit()
    },
    onTipoCalculoSTChange() {
      if (this.local.OP_PISST_TIPO_CALCULO !== '1') {
        this.local.VL_PISST_ALIQUOTA_PERCENT = 0
      }
      this.emit()
    },
    emit() {
      this.$emit('input', this.local)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeProdutoPis.vue